/** Shown in city pickers; search/browse with no city filter when selected. */
export const ALL_LOCATIONS_LABEL = 'All locations';

export function isAllLocationsSelection(city) {
  const key = normalizeCityKey(city);
  return !key || key === 'all' || key === 'all locations';
}

export function displayCityLabel(city) {
  if (isAllLocationsSelection(city)) return ALL_LOCATIONS_LABEL;
  return canonicalCityLabel(city) || city || ALL_LOCATIONS_LABEL;
}

/**
 * Normalize city string for deduplication (case + whitespace).
 */
export function normalizeCityKey(raw) {
  if (raw == null || raw === '') return '';
  const s = String(raw).trim().replace(/\s+/g, ' ');
  return s ? s.toLowerCase() : '';
}

/**
 * Single display label: "pune" / "PUNE" → "Pune"
 */
export function canonicalCityLabel(raw) {
  const s = String(raw ?? '')
    .trim()
    .replace(/\s+/g, ' ');
  if (!s) return '';
  return s
    .split(/\s+/)
    .map((word) => {
      if (!word) return '';
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(' ');
}

/**
 * Merge API cities + optional extra selection into unique canonical labels, sorted A–Z.
 */
export function mergeUniqueCanonicalCities(cities, extra) {
  const map = new Map();
  for (const c of cities || []) {
    const key = normalizeCityKey(c);
    if (!key) continue;
    if (!map.has(key)) map.set(key, canonicalCityLabel(c));
  }
  if (extra) {
    const key = normalizeCityKey(extra);
    if (key && !map.has(key)) map.set(key, canonicalCityLabel(extra));
  }
  return Array.from(map.values()).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' })
  );
}

/** City picker list: “All locations” first, then unique stay cities. */
export function cityPickerOptions(cities, extra) {
  const merged = mergeUniqueCanonicalCities(cities, extra).filter(
    (c) => !isAllLocationsSelection(c)
  );
  return [ALL_LOCATIONS_LABEL, ...merged];
}
